var config = process.env.BROWSER ? require('cfg').default : require('config');

module.exports = {
    FONT: {
        name: 'Roboto',
        fontFamily: '"Roboto", sans-serif',
        fontStyle: 'normal',
        thin: 300,
        normal: 400,
        bold: 700,
        textTransform: '',
        gFontName: 'Roboto',
        gWeights: '300,400,700',
        gSubsets: ''
    },
    LAYER: {
        topOverlay: false,
        backgroundPositionY: 'center',
        backgroundPositionX: 'center',
        backgroundSize: 'cover',
        opacity: 1,
        translateY: 50,
        translateX: 50,
        scale: 1,
        backgroundImage: `${config.assets}/assets/sm_cover.png`
    },
    BRANDING: {
        position: 'bottom',
        order: 'ltr',
        placement: 'relative',
        alignment: 'edges',
        visibility: 'both',
        height: 'auto',
        width: 'auto',
        padding: '10 10 10 10',
    }
};



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/templates/TemplateConstants.js
 **/